!function ($, global) {
    'use strict';

    var $window = $(global);
    var $document = $(global.document);

    var PREFIX = 'wave-';
    var CLASS_MAIN = PREFIX + 'hidden';
    var CLASS_ACTIVE = PREFIX + 'active';
    var CLASS_SHOWING = PREFIX + 'showing';
    var SELECTOR = '.' + CLASS_MAIN;
    var CLASSES = CLASS_ACTIVE + ' ' + CLASS_SHOWING + ' ' + CLASS_MAIN;

    var DEFAULTS = {
        offset: 50,
        interval: 50,
        init: false
    };

    var settings = $.extend(DEFAULTS, $.waveActivateSettings);

    var pending = false;

    var appear = function () {
        var position = $window.height() + $window.scrollTop() - settings.offset;

        $(SELECTOR).each(function (index, element) {
            var $item = $(element);

            if ($item.offset().top < position) {
                $item
                    .toggleClass(CLASSES)
                    .delay(settings.interval * (index + 1))
                    .delayed('removeClass', CLASS_ACTIVE)
                    .delay(500)
                    .delayed('removeClass', CLASS_SHOWING);
            }
        });
    };

    function WaveActivate() {
        this._active = false;
    }

    WaveActivate.prototype = {
        constructor: WaveActivate,

        init: function () {
            if (!this._active) {
                this._active = true;

                appear();

                $document.on('scroll', function () {
                    if (!pending) {
                        pending = true;

                        setTimeout(function () {
                            pending = false;
                            appear();
                        }, 50)
                    }
                });
            }
        }
    };


    $.waveActivate = new WaveActivate();


    if (settings.init) {
        $(function () {
            setTimeout(function () {
                $.waveActivate.init();
            }, typeof settings.init === 'number' ? settings.init : 4e3);
        });
    }

}(jQuery, window);